import { render, staticRenderFns } from "./SSN.vue?vue&type=template&id=1b9a76bc"
import script from "./SSN.vue?vue&type=script&lang=js"
export * from "./SSN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports